export default __webpack_public_path__ + "static/media/error-red-small-circle-icon.fd15cf17.svg";